export default [
  {
    title: 'breadcrumb.service',
    route: 'service-system',
    icon: 'CastIcon',
    resource: 'service',
    action: 'read',
    tag: 0,
    tagVariant: 'danger',
  },
]
